import { useMutation, useQueryClient } from "react-query";

import { queryKeyPrefix } from "api/services/treatment/hooks/useGetTreatmentSchedules";
import { useApiClient } from "api/useApiClient";

export const useDeleteTreatmentSchedule = () => {
  const client = useApiClient();
  const queryClient = useQueryClient();

  return useMutation<null, Error, { treatmentScheduleID: number }>({
    mutationFn: ({ treatmentScheduleID }) => client.deleteTreatmentSchedule(treatmentScheduleID),
    onSuccess: () => {
      queryClient.invalidateQueries(queryKeyPrefix);
    },
  });
};
